import styled from "styled-components";

export const SectionWrapper = styled.section`
  padding: 60px 0 75px;
  background-color: #faf7f2;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 42px 0 55px;
  }

  /* Override any global iframe height constraints */
  #watchVideos iframe,
  iframe {
    width: 100% !important;
    height: 100% !important;
    border: 0 !important;
    display: block;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;

  @media (max-width: 480px) {
    padding: 0 16px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 24px;
    gap: 16px;
  }
`;

export const HeaderLeft = styled.div`
  max-width: 680px;
`;

export const Eyebrow = styled.span`
  display: inline-block;
  font-size: 13px;
  font-weight: 700;
  color: #d87b1c;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  margin-bottom: 6px;
`;

export const SectionTitle = styled.h2`
  font-family: "Playfair Display", Georgia, serif;
  font-size: 36px;
  font-weight: 700;
  color: #1c1917;
  line-height: 1.25;
  margin: 0 0 8px 0;
  letter-spacing: -0.3px;

  @media (max-width: 768px) {
    font-size: 28px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

export const Subtitle = styled.p`
  font-size: 15px;
  color: #6b635b;
  line-height: 1.5;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    align-self: flex-end;
  }
`;

export const NavButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .swiper-button-prev7,
  .swiper-button-next7 {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    border: 1.5px solid #ebd9c8;
    background: #ffffff;
    color: #1c1917;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    font-size: 14px;

    &:hover:not(.swiper-button-disabled) {
      background: #d87b1c;
      color: #ffffff;
      border-color: #d87b1c;
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(216, 123, 28, 0.28);
    }

    &.swiper-button-disabled {
      opacity: 0.35;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
`;

export const SwiperWrapper = styled.div`
  width: 100%;
  position: relative;

  .swiper {
    padding-bottom: 12px;
  }

  .swiper-slide {
    height: auto;
    display: flex;
  }
`;

export const VideoCard = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #ebd9c8;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),
              box-shadow 0.3s cubic-bezier(0.16, 1, 0.3, 1),
              border-color 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 16px 32px rgba(216, 123, 28, 0.12);
    border-color: #d87b1c;
  }
`;

export const VideoFrameWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #0f0f0f;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    border: 0 !important;
  }
`;

export const CardBody = styled.div`
  padding: 18px 20px 20px;
  display: flex;
  flex-direction: column;

  @media (max-width: 480px) {
    padding: 14px 16px 16px;
  }
`;

export const VideoCardTitle = styled.h3`
  font-family: "Playfair Display", Georgia, serif;
  font-size: 19px;
  font-weight: 700;
  color: #1c1917;
  line-height: 1.35;
  margin: 0 0 5px 0;

  @media (max-width: 480px) {
    font-size: 17px;
  }
`;

export const VideoCardSub = styled.p`
  color: #a8600e;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
`;

export default SectionWrapper;
